import PageTitle from "../../../Components/UI/PageTitle";
import AddOrEditPackage from "../../../Components/AddOrEditPackage/AddOrEditPackage";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getPackageDataToEdit } from "../../../apis";
import Loader from "../../../Components/Loader";

const UpdatePackage = () => {
  const { packageId, packageManagementId } = useParams();
  const [packageData, setPackageData] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    getPackageDataToEdit(packageId)
      .then((response) => {
        setPackageData(response.data.data.original);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [packageId]);

  const handleCoursesData = packageData?.courses
    ? packageData.courses.map((course) => ({
        course_name: course.course_id,
        course_price: course.e_money,
        pv_upliner: course.weight,
      }))
    : [];

  if (isLoading) return <Loader />;
  return (
    <>
      <PageTitle
        title={"Update Package"}
        BreadcrumbItems={[
          {
            title: "Home",
            link: "/",
          },
          {
            title: "Package Management",
            link: "/package-management",
          },
          {
            title: "Package List",
            link: `/package-management/${packageManagementId}?filterBy=partner_type`,
          },
          {
            title: "Package Details",
            link: `/package-management/${packageManagementId}/package-details/${packageId}`,
          },
          {
            title: "Update Package",
          },
        ]}
      />
      {!isLoading && (
        <AddOrEditPackage
          forEdit={true}
          dataToEdit={packageData || {}}
          coursesData={handleCoursesData}
        />
      )}
    </>
  );
};

export default UpdatePackage;
